<template>
  <header id="mobile-header" class="mobile-show-content fixed w-full bg-white shadow-md py-10">
    <nav class="px-12 relative">
      <div class="flex justify-between items-center gap-6">
        <div class="flex items-center">
          <div>
            <the-nav-bar-button></the-nav-bar-button>
          </div>
          <a href="/" class="block mr-4 lg:mr-0">
            <img src="/assets/images/logo.png" alt="drybrush Gallery - Filipino Art"
              class="w-120 lg:w-140 object-fit" />
          </a>
          <div class="flex items-center gap-6">
            <i class="fas fa-phone-alt text-12 text-orange"></i>
            <a href="viber://chat?number=639175652917" class="underline font-bold text-12 link link-accent whitespace-no-wrap">{{ phone }}</a>
          </div>
        </div>
        <div class="col-span-3 md:gap-20 lg:gap-0 flex items-center">
          <slot name="icons"></slot>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
import TheNavbarSearchResult from "../../Modules/Search/TheNavbarSearchResult.vue";
import TheNavBarMobileItem from "./TheNavBarMobileItem.vue";
import TheNavBarButton from "./TheNavBarButton.vue";
import SearchForm from "../../Universal/SearchForm.vue";

export default {
  components: {
    TheNavbarSearchResult,
    TheNavBarMobileItem,
    TheNavBarButton,
    SearchForm,
  },

  props: {
    menu: Object,
    phone: String,
  },

  computed: {
    defaultSearchValue() {
      return new URLSearchParams(window.location.search).get("search") ?? null;
    },
  },
};
</script>
